import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';

@Component({
  selector: 'wl-solar-panels-result-overview-map[rendering][mapUrl]',
  styleUrls: ['./solar-panels-result-overview-map.component.scss'],
  templateUrl: './solar-panels-result-overview-map.component.html',
})
export class SolarPanelsResultOverviewMapComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: InnogyComponentRendering;

  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() mapUrl!: string;

  get fields() {
    return this.rendering?.fields;
  }
}
